import React from 'react'
import { Box, Typography } from '@mui/material'
import { Button, Modal } from '@/design-system'

export interface DuplicateGalleryModalProps {
  open: boolean
  galleryName: string
  onClose: () => void
  onConfirm: () => void
}

export function DuplicateGalleryModal({
  open,
  galleryName,
  onClose,
  onConfirm,
}: DuplicateGalleryModalProps) {
  return (
    <Modal open={open} onClose={onClose} title='Duplicate gallery?'>
      <Typography sx={{ fontSize: 14, color: 'var(--ds-ink-muted)', mb: 3 }}>
        This creates a private copy of “{galleryName}” with the same scene, frame, materials, and
        photo placements — safe to experiment without changing the original.
      </Typography>
      <Box display='flex' justifyContent='flex-end' gap={1.5}>
        <Button variant='ghost' onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='primary'
          onClick={() => {
            onConfirm()
            onClose()
          }}
        >
          Duplicate
        </Button>
      </Box>
    </Modal>
  )
}
